
class SendPaymentDetailsResponse {
    public response: boolean;
}

export default SendPaymentDetailsResponse;


// WEBPACK FOOTER //
// ./src/services/response/SendPaymentDetailsResponse.tsx